import { ProgressFooterToolbar } from 'ipro-ui-kit-vuejs/src/components';
import {
  mapGetters, mapState, mapMutations,
} from 'vuex';

import AssessmentFieldPage from '@/core/assessment/assessment-field/AssessmentFieldPage.vue';
import { WorkerAssessmentService } from '@/core/worker-assessment';
import { WorkerOneTimePassService } from '@/core/worker-one-time-pass';
import { OneTimePassRoutesMixin } from '@/portal/one-time-pass/mixins';

// @vue/component
export default {
  components: {
    AssessmentFieldPage,
    ProgressFooterToolbar,
  },
  mixins: [
    OneTimePassRoutesMixin,
  ],
  data() {
    return {
      currentField: null,
      loadingNext: false,
      loadingPrevious: false,
    };
  },
  computed: {
    ...mapGetters('oneTimePass', ['getAnswer']),
    ...mapGetters('oneTimePass', {
      filteredFields: 'filteredAssessmentFields',
    }),
    ...mapState('oneTimePass', ['answers', 'workerAssessment']),
    currentFieldUuid() {
      return this.$route.params.assessmentFieldUuid || this.filteredFields[0].uuid;
    },
    answer: {
      get() {
        return this.getAnswer(this.currentFieldUuid);
      },
      set(value) {
        this.setAnswer({
          answer: value,
          fieldUuid: this.currentFieldUuid,
        });
      },
    },
    currentFieldIndex() {
      return this.filteredFields.findIndex(field => field.uuid === this.currentFieldUuid);
    },
    isFieldDirty() {
      return _.get(this.$refs.observer, 'ctx.dirty', true);
    },
  },
  created() {
    this.currentField = this.filteredFields[this.currentFieldIndex];
  },
  methods: {
    ...mapMutations('oneTimePass', ['setAnswer', 'setWorkerOneTimePass']),
    async onNextClick() {
      this.loadingNext = true;
      await this.saveAnswers();
      if (this.currentFieldIndex === this.filteredFields.length - 1) {
        this.setWorkerOneTimePass(null);
        WorkerOneTimePassService.clearCache();
        this.$router.push(this.routes.criteriaSummary);
      } else {
        const nextField = this.filteredFields[this.currentFieldIndex + 1];
        this.$router.push(_.merge({}, this.routes.assessment, {
          params: { assessmentFieldUuid: nextField.uuid },
        }));
      }
    },
    async onPreviousClick() {
      if (this.currentFieldIndex === 0) {
        return;
      }
      this.loadingPrevious = true;
      await this.saveAnswers();
      const previousField = this.filteredFields[this.currentFieldIndex - 1];
      this.$router.push(_.merge({}, this.routes.assessment, {
        params: { assessmentFieldUuid: previousField.uuid },
      }));
    },
    async saveAnswers() {
      try {
        if (this.isFieldDirty) {
          await WorkerAssessmentService.updateWorkerAssessment(this.workerAssessment, this.answers);
        }
      } finally {
        this.loadingNext = false;
        this.loadingPrevious = false;
      }
    },
  },
};
